import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown, Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import { Toaster } from "../../components/Toaster/Toster";
import { getBrandsApi } from "../../../services/apis/BrandApi";
import ReactPaginate from "react-paginate";
import moment from "moment";
import useDebounce from "../../components/common/Debounce";
import * as XLSX from "xlsx";
import { getLogActivityDataApi, getLogTypeDataApi, getUserRoleDataApi } from "../../../services/apis/LogActivityApi";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from "react-device-detect";
import { useSelector } from "react-redux";
import { CreatelogActivityApi } from "../../../services/apis/IpAddress";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "User Role", sortingVale: "userRole" },
  { heading: "Log Type", sortingVale: "logType" },
  { heading: "Device Type", sortingVale: "deviceType" },
  { heading: "Ip Address", sortingVale: "ipAddress" },
  { heading: "Country", sortingVale: "countryCode" },
  { heading: "State", sortingVale: "regionCode" },
  { heading: "City", sortingVale: "city" },
  { heading: "Description", sortingVale: "description" },
  { heading: "Created At", sortingVale: "createdAt" },
];

const excelHeadData = [
  { heading: "User Role", value: "User Role" },
  { heading: "Log Type", value: "Log Type" },
  { heading: "Device Type", value: "Device Type" },
  { heading: "Ip Address", value: "Ip Address" },
  { heading: "Country", value: "Country" },
  { heading: "State", value: "State" },
  { heading: "City", value: "City" },
  { heading: "Description", value: "Description" },
  { heading: "Created At", value: "createdAt" },
];
const LogActivity = () => {
  const [sort, setSortata] = useState(10);
  const [loading, setLoading] = useState(false);
  const [updateCuisines, setUpdateBrands] = useState(false);
  const [LogActivityData, setLogActivityData] = useState([]);
  const [allLogActivityData, setAllLogActivityData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [selectedUserRole, setSelectedUserRole] = useState("");
  const [selectedLogType, setSelectedLogType] = useState({
    viewLogType:"",
    apiLogType:""
  });
  const [userRole,setUserRole]=useState([]);
  const [logType,setLogType]=useState([]);
  const informationIp = useSelector((data) => data?.ipAddressReducers?.ipAddressData);
  const user = useSelector((data) => data?.userReducers?.user);
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const deviceType = {
    type: isMobile
      ? "Mobile"
      : isTablet
      ? "Tablet"
      : isDesktop
      ? "Desktop"
      : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other",
  };

  const debouncedSearchValue = useDebounce(searchInputValue, 500);

  const fetchLogActivityData = async (sortValue) => {
    // Set loading to true when the API call starts
    setLoading(true);
    try {
      const res = await getLogActivityDataApi(
        currentPage,
        sort,
        sortValue,
        searchInputValue,
        selectedUserRole,
        selectedLogType?.apiLogType
      );
      const resData = res?.data;
      setLogActivityData(resData);


      const limit = 15000
      const resD = await getLogActivityDataApi(
        1,
        limit,
        sortValue,
        searchInputValue,
        selectedUserRole,
        selectedLogType?.apiLogType
      );

      setAllLogActivityData(resD?.data?.all_logs);
      // allLogActivityData, setAllLogActivityData
    } catch (error) {
      // Catch and handle errors
      console.error("Error fetching:", error);
      Toaster.error("Failed to load. Please try again.");
    } finally {
      // Always set loading to false when the API call is done (whether successful or failed)
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogActivityData();
  }, [
    updateCuisines,
    currentPage,
    sort,
    debouncedSearchValue,
    selectedUserRole,
    selectedLogType?.apiLogType,
  ]);


  const fetchUserRoleData = async () => {
    try {
      const res = await getUserRoleDataApi();
      const resData = res?.data?.data;
      setUserRole(resData);
    } catch (error) {
      Toaster.error("Failed to load. Please try again.");
    }
  };

  const fetchLogTypeData = async () => {
    try {
      const res = await getLogTypeDataApi();
      const resData = res?.data?.data;
      setLogType(resData);
      // console.log("ress",resData)
      // setUserRole(resData);
    } catch (error) {
      Toaster.error("Failed to load. Please try again.");
    }
  };

  useEffect(() => {
    fetchUserRoleData();
    fetchLogTypeData();
  }, []);
  
  function SotingData(name, ind) {
    // const sortedPeople = [...brandList?.brands];
    if (iconData.complete) {
      const sortValue = { value: name, type: "asc" };
      fetchLogActivityData(sortValue);
    } else {
      const sortValue = { value: name, type: "dsc" };
      fetchLogActivityData(sortValue);
    }
  }

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };


   const loggedActivity = async (logType) => {
      const data = {
        id: user?._id,
        ipAddress: informationIp?.query,
        lat: informationIp?.lat,
        long: informationIp?.lon,
        logType:logType,
        deviceType: JSON.stringify(deviceType),
        city: informationIp?.city,
        countryCode: informationIp?.countryCode,
        regionCode: informationIp?.region,
      };
      try {
        const res = await CreatelogActivityApi(data);
         if(res?.data?.success){
          fetchLogActivityData();
         }
      } catch (err) {
        console.log(err);
      }
    };

    const exportToExcel = () => {
      const table = document.querySelector("table");
  
      if (!allLogActivityData || allLogActivityData.length === 0) {
        alert("No valid data to export.");
        return;
      }
  
      const headers = excelHeadData
        ?.filter(
          (item) =>
            item?.value !== "s.no." &&
            item?.value !== "createdAt" &&
            item?.value !== "updatedAt" &&
            item?.value !== "action")
        ?.map((item) => `<th>${item?.value}</th>`)
        ?.join("");
  
      const rows = allLogActivityData
        ?.map((data, ind) => {
          return `
          <tr>
            <td>${data?.userRole}</td>
            <td>${data?.logType}</td>
            <td>${data?.deviceType}</td>
            <td>${data?.ipAddress}</td>
            <td>${data?.countryCode}</td>
            <td>${data?.regionCode}</td>
            <td>${data?.city}</td>
            <td>${data?.description}</td>
          </tr>
        `;
        })
        .join("");
  
      const updatedTable = document.createElement("table");
      updatedTable.innerHTML = 
      `<thead><tr>${headers}</tr></thead>
        <tbody>${rows}</tbody>`;
  
      const workbook = XLSX.utils.table_to_book(updatedTable, {
        sheet: "UserList",
      });
      XLSX.writeFile(workbook, "UserList.xlsx");
      loggedActivity("exportlogactivity")
    };

  const getLogBadgeClass = (logType) => {
    const normalizedLog = logType?.trim();
    switch (normalizedLog) {
      case "login":
        return "bg-success";
      case "logout":
        return "bg-danger";
      case "signup":
        return "bg-info";
      case "changepassword":
        return "bg-warning";
      case "export":
        return "bg-blue";
      case "import":
        return "bg-info";
      case "adduser":
        return "bg-success";
      case "useredit":
        return "bg-warning";
      case "delete":
        return "bg-danger";
      case "employeecreate":
        return "bg-success";
      case "employeeedit":
        return "bg-warning";
      case "employeedelete":
        return "bg-danger";
      case "exportlogactivity":
        return "bg-blue";
      case "importimage":
        return "bg-info";
      case "createrole":
        return "bg-success";
      case "roleedit":
        return "bg-warning";
      case "roledelete":
        return "bg-danger";
      default:
        return {
          className: "bg-light",
        }; // Default case
    }
  };

  // const getLogBadgeClass = (log) => {
  //   const normalizedLog = log?.trim();
  //   switch (normalizedLog) {
  //     case "login":
  //       return "bg-success";
  //     case "logout":
  //       return "bg-danger";
  //     case "changePassword":
  //       return "bg-blue";
  //     case "useradd":
  //       return "bg-success";
  //       case "useredit":
  //         return "bg-info";
  //     case "delete":
  //       return "bg-danger";
  //     default:
  //       return "bg-light";
  //   }
  // };

  return (
    <>
      <ToastContainer />

      <Loader visible={loading} />
      <PageTitle
        activeMenu={`Log Activity (${allLogActivityData?.length})`}
        motherMenu={"Home"}
        motherMenuLink={"/dashboard"}
      />
      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              <div className="d-flex align-items-center gap-1">
                Filter :
                <Dropdown onSelect={(e) => setSelectedUserRole(e)}>
                  <Dropdown.Toggle
                    variant="primary"
                    size="sm"
                    className="mt-2 mb-2 text-capitalize">
                    User Role : {selectedUserRole ? selectedUserRole : "All"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item eventKey="">All</Dropdown.Item>
                    {
                     userRole?.map((val,ind)=>{
                      return(
                      <div className="text-capitalize" key={ind}>
                        <Dropdown.Item eventKey={val?.name}>{val?.name}</Dropdown.Item>
                      </div>)
                     })
                    }
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown>
                  <Dropdown.Toggle variant="primary" size="sm" className="mt-2 mb-2 text-capitalize">
                    Log Type : {selectedLogType?.viewLogType ? selectedLogType?.viewLogType : "All"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                  
                  {
                     logType?.map((val,ind)=>{
                      return(
                      <div className="text-capitalize" key={ind}>
                        <Dropdown.Item onClick={() => setSelectedLogType({apiLogType:val?.logType,viewLogType:val?.logName})} 
                         eventKey={val?.logType}>{val?.logName}</Dropdown.Item>
                      </div>)
                     })
                    }
                    {/* <Dropdown.Item eventKey="">All</Dropdown.Item>
                    <Dropdown.Item eventKey="login">Login</Dropdown.Item>
                    <Dropdown.Item eventKey="logout">Logout</Dropdown.Item>
                    <Dropdown.Item eventKey="changePassword">Change Password</Dropdown.Item>
                    <Dropdown.Item eventKey="useradd">Add User</Dropdown.Item>
                    <Dropdown.Item eventKey="useredit">Edit User</Dropdown.Item>
                    <Dropdown.Item eventKey="delete">Delete User</Dropdown.Item>
                    <Dropdown.Item eventKey="import">Import</Dropdown.Item>
                    <Dropdown.Item eventKey="export">Export</Dropdown.Item>
                    <Dropdown.Item eventKey="employeecreate">Create Employee</Dropdown.Item>
                    <Dropdown.Item eventKey="employeeedit">Edit Employee</Dropdown.Item>
                    <Dropdown.Item eventKey="employeedelete">Delete Employee</Dropdown.Item> */}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <Button
                  variant="secondary"
                  type="button"
                  className="mb-2 secondary me-2"
                  onClick={exportToExcel}
                  >
                  Export
                </Button>

            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setSortata("2")}> 2 </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("5")}> 5 </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("10")}> 10 </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("15")}> 15 </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("20")}> 20 </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        Entries
                      </label>
                    </div>
                    <div className="dataTables_filter">
                      <label>
                        Search :{" "}
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          onChange={(e) => setSearchInputValue(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                 {LogActivityData?.all_logs?.length > 0 ?
                   <table className="display dataTable no-footer w-100">
                    <thead>
                      <tr>
                        {theadData?.map((item, ind) => {
                          return (
                            <th
                              key={ind}
                              onClick={() => {
                                SotingData(item?.sortingVale, ind);
                                setIconDate((prevState) => ({
                                  complete: !prevState.complete,
                                  ind: ind,
                                }));
                              }}>
                              {item.heading}
                              <span>
                                {ind !== iconData.ind && (
                                  <i
                                    className="fa fa-sort ms-2 fs-12"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                                {ind === iconData.ind &&
                                  (iconData.complete ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-12"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-12"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ))}
                              </span>
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {LogActivityData?.all_logs?.map((data, ind) => {
                        let deviceTypeData = { os: "Unknown", type: "Unknown" };
                        try {
                          deviceTypeData = JSON.parse(data?.deviceType);
                        } catch (error) {
                          // console.error("Error parsing deviceType:", error);
                        }
                        return (
                          <tr key={ind}>
                            <td>
                              <strong>
                                {(currentPage - 1) * sort + ind + 1}
                              </strong>
                            </td>
                            <td className="">{data?.userRole}</td>
                            <td className="">
                              <span className={`text-capitalize badge light ${getLogBadgeClass(data?.logType)}`}>
                                {data?.logName ? data?.logName : data?.logType}
                              </span>
                            </td>
                            <td className="">{`${deviceTypeData?.os} , ${deviceTypeData?.type}`}</td>
                            <td className="">{data?.ipAddress}</td>
                            <td className="">{data?.countryCode}</td>
                            <td className="">{data?.regionCode}</td>
                            <td className="">{data?.city}</td>
                            <td className="text-capitalize">{data?.description}</td>
                            <td>{moment(data?.createdAt).format("DD MMM YYYY, h:mm:ss a")}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                   </table>
                   :
                  <h4 className="text-danger text-center">No Record Found</h4> 
                  } 
                  <div>
                    {/* {LogActivityData?.data?.length < LogActivityData?.total && ( */}
                    <div className="d-sm-flex text-center justify-content-end align-items-center mt-3">
                      <div className="pagination-container">
                        <ReactPaginate
                          pageCount={Math.ceil(
                            LogActivityData?.pagination?.totalLogs /
                              LogActivityData?.pagination?.rowPerPage
                          )}
                          pageRangeDisplayed={1}
                          marginPagesDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName="pagination"
                          activeClassName="selected"
                          disabledClassName="disabled"
                        />
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LogActivity;
